/* mx4ever homepage finder: "Shop by bike | Shop by rider" tabs.
   The bike tab is the existing ymm-selector. The rider tab works out the current rider's size per brand chart
   (MxSizeEngine from mx-rider.js) and links to the store's collections filtered by those sizes. */
(() => {
  if (customElements.get('mx-shop-finder')) return;
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const TAB_KEY = 'mx:finder-tab';

  // Search & Discovery groups sizes ("Small", "X Large"); compare on a common short form
  const normSize = (s) => {
    const n = String(s).toUpperCase().replace(/[\s-]+/g, '');
    const map = { SMALL: 'S', MEDIUM: 'M', LARGE: 'L', XLARGE: 'XL', XXLARGE: 'XXL', '2XL': 'XXL', XXXL: '3XL', XSMALL: 'XS', EXTRASMALL: 'XS', EXTRALARGE: 'XL' };
    return map[n] || n;
  };

  class MxShopFinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.cfg = JSON.parse(this.querySelector('script[data-finder]').textContent);
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panel = this.querySelector('[data-rider-panel]');
      this.cache = new Map();
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab, true));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const i = this.tabs.indexOf(tab);
          const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : this.tabs.length - 1)) % this.tabs.length];
          this.select(next.dataset.tab, true);
          next.focus();
        });
      });
      document.addEventListener('mx-rider:change', () => {
        if (this.current === 'rider') this.renderRider();
      });
      let start = 'bike';
      try {
        start = sessionStorage.getItem(TAB_KEY) || 'bike';
      } catch (e) {}
      this.select(start, false);
    }

    select(name, remember) {
      this.current = name;
      this.tabs.forEach((tab) => {
        const on = tab.dataset.tab === name;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`).hidden = !on;
      });
      if (remember) {
        try {
          sessionStorage.setItem(TAB_KEY, name);
        } catch (e) {}
      }
      if (name === 'rider') this.renderRider();
    }

    t(key, vars) {
      let s = this.cfg.strings[key] || key;
      if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(v);
      return s;
    }

    // Rider tab = the bike tab's own row (ymm-selector classes): Rider ▾  Gear ▾  [Show 25 jerseys] [Edit rider]
    renderRider() {
      const R = window.MxRiders;
      if (!R || !window.MxSizeEngine) {
        this.panel.innerHTML = '';
        return;
      }
      const id = this.id || 'mx-finder';
      if (!this.form) {
        this.panel.innerHTML = `<div class="ymm-selector ymm-selector--horizontal mx-finder__rider">
          <form class="ymm-selector__form" data-rider-form>
            <div class="ymm-selector__fields">
              <div class="ymm-selector__field">
                <label class="form__label ymm-selector__label" for="${id}-rider">${esc(this.t('rider_label'))}</label>
                <div class="select">
                  <select id="${id}-rider" class="select__select ymm-selector__select" data-rider-select></select>
                  <span class="svg-wrapper">${this.caret()}</span>
                </div>
              </div>
              <div class="ymm-selector__field">
                <label class="form__label ymm-selector__label" for="${id}-gear">${esc(this.t('gear_label'))}</label>
                <div class="select">
                  <select id="${id}-gear" class="select__select ymm-selector__select" data-gear-select></select>
                  <span class="svg-wrapper">${this.caret()}</span>
                </div>
              </div>
            </div>
            <div class="ymm-selector__actions">
              <button type="submit" class="button button--primary ymm-selector__submit" data-go></button>
              <button type="button" class="button button--secondary ymm-selector__reset" data-edit>${esc(this.t('edit'))}</button>
            </div>
          </form>
        </div>`;
        this.form = this.panel.querySelector('[data-rider-form]');
        this.riderSel = this.form.querySelector('[data-rider-select]');
        this.gearSel = this.form.querySelector('[data-gear-select]');
        this.go = this.form.querySelector('[data-go]');
        this.editBtn = this.form.querySelector('[data-edit]');
        this.riderSel.addEventListener('change', () => {
          if (this.riderSel.value === '__add') {
            const cur = R.store.current();
            this.riderSel.value = cur ? cur.id : '';
            R.openForm(null);
          } else if (this.riderSel.value) R.store.select(this.riderSel.value);
        });
        this.gearSel.addEventListener('change', () => {
          try {
            sessionStorage.setItem('mx:finder-gear', this.gearSel.value);
          } catch (e) {}
          this.updateButton();
        });
        this.editBtn.addEventListener('click', () => {
          const cur = R.store.current();
          if (cur) R.openForm(cur.id);
        });
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          const rider = R.store.current();
          if (!rider) return R.openForm(null);
          const st = this.state[this.gearSel.value];
          if (!st) return;
          if (st.href) window.location.href = st.href;
          else if (st.res.missing) R.openForm(rider.id);
        });
      }
      const v = R.store.read();
      const rider = R.store.current();
      // rider dropdown
      this.riderSel.innerHTML =
        (rider ? '' : `<option value="">${esc(this.t('choose_rider'))}</option>`) +
        v.riders.map((r) => `<option value="${esc(r.id)}"${rider && r.id === rider.id ? ' selected' : ''}>${esc(r.name)}</option>`).join('') +
        `<option value="__add">${esc(this.t('add_option'))}</option>`;
      this.editBtn.disabled = !rider;
      // gear dropdown
      let gear = this.gearSel.value;
      if (!gear) {
        try {
          gear = sessionStorage.getItem('mx:finder-gear') || '';
        } catch (e) {}
      }
      this.state = {};
      if (rider) for (const c of this.cfg.cats) this.state[c.key] = { cat: c, res: this.sizesFor(c, rider), href: null, count: null };
      this.gearSel.innerHTML = this.cfg.cats.map((c) => `<option value="${esc(c.key)}">${esc(this.optionText(c.key))}</option>`).join('');
      this.gearSel.value = this.cfg.cats.some((c) => c.key === gear) ? gear : this.cfg.cats[0].key;
      this.gearSel.disabled = !rider;
      this.updateButton();
      if (rider) {
        const token = (this.token = {});
        for (const st of Object.values(this.state)) {
          if (!st.res.sizes.length) continue;
          this.lookup(st.cat, st.res, rider).then((found) => {
            if (token !== this.token) return;
            // lookup failed: still go to the collection, just without the size filter and count
            const hit = found || { href: `${(this.dataset.root || '/').replace(/\/+$/, '')}${this.collectionPath(st.cat, st.res.group)}`, count: null };
            st.href = hit.href;
            st.count = hit.count;
            const opt = this.gearSel.querySelector(`option[value="${CSS.escape(st.cat.key)}"]`);
            if (opt) opt.textContent = this.optionText(st.cat.key);
            this.updateButton();
            this.remember(rider);
          });
        }
      }
    }

    // keep this rider's gear links for the visit, so collection pages can offer "Also in Simon's size: Jerseys (20) · …".
    // Saved per language (keyed by the locale root, '' or '/da'), so switching language never shows the other one's links.
    remember(rider) {
      const items = {};
      for (const [key, st] of Object.entries(this.state || {})) {
        if (st.href && st.count) items[key] = { href: st.href, count: st.count, label: this.t(`cat_${key}`) };
      }
      const riderKey = `${rider.id}|${rider.updated}`;
      const root = (this.dataset.root || '/').replace(/\/+$/, '');
      try {
        let saved = null;
        try {
          saved = JSON.parse(sessionStorage.getItem('mx:finder-links'));
        } catch (e) {}
        if (!saved || saved.rider !== riderKey || !saved.byRoot) saved = { rider: riderKey, byRoot: {} };
        saved.byRoot[root] = { order: this.cfg.cats.map((c) => c.key), items };
        sessionStorage.setItem('mx:finder-links', JSON.stringify(saved));
      } catch (e) {}
    }

    optionText(key) {
      const cat = this.t(`cat_${key}`);
      const st = this.state && this.state[key];
      if (!st) return cat;
      const r = st.res;
      if (r.sizes.length) {
        const size = key === 'boot' ? `EU ${r.shown.join('/')}` : r.shown.join(' / ');
        if (st.count === 0) return this.t('opt_zero', { cat, size });
        return st.count != null ? this.t('opt_count', { cat, size, n: st.count }) : this.t('opt', { cat, size });
      }
      if (r.missing) return this.t('opt_missing', { cat, what: this.t(`m_${r.missing}`) });
      return this.t('opt_none', { cat });
    }

    updateButton() {
      const rider = window.MxRiders.store.current();
      const st = this.state && this.state[this.gearSel.value];
      let label = this.t('find');
      let ready = false;
      let disabled = false;
      if (!rider) {
        label = this.t('add_rider');
        ready = true;
      } else if (st && st.res.missing) {
        label = this.t('add_what', { what: this.t(`m_${st.res.missing}`) });
      } else if (st && !st.res.sizes.length) {
        disabled = true;
      } else if (st && st.count === 0) {
        label = this.t('zero');
        disabled = true;
      } else if (st && st.href) {
        label = st.count != null ? this.t('show', { n: st.count, cat: this.t(`catl_${st.cat.key}`) }) : this.t('find');
        ready = true;
      } else {
        disabled = true; // still looking up the collection
      }
      this.go.textContent = label;
      this.go.disabled = disabled;
      this.go.classList.toggle('is-ready', ready);
    }

    caret() {
      return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';
    }

    // The rider's size in every brand chart of this category (union across brands)
    sizesFor(cat, rider) {
      const group = rider.group || 'adult';
      const handles = cat.tables[group] || cat.tables.adult;
      const sizes = [];
      const names = new Set(); // size + the chart's other names for it (youth trousers are sold as US 22-28)
      const shown = [];
      let missing = null;
      let tried = 0;
      for (const h of handles) {
        const table = this.cfg.tables[h];
        if (!table || !table.rows) continue;
        tried++;
        const product = { use: cat.use, sizes: Object.fromEntries(table.rows.map((r) => [r.size, [r.size]])) };
        const r = window.MxSizeEngine.recommend(rider, table, product);
        if ((r.fit === 'good' || r.fit === 'between') && r.size && !sizes.includes(r.size)) {
          sizes.push(r.size);
          const row = table.rows.find((x) => x.size === r.size);
          const aliases = row ? Object.values(row.aliases || {}) : [];
          names.add(r.size);
          if (cat.use === 'trouser') aliases.forEach((a) => names.add(a)); // boots' US/UK numbers would clash with EU sizes
          const alt = cat.use === 'trouser' ? aliases.find((a) => a !== r.size) : null;
          shown.push(alt ? `${alt} (${r.size})` : r.size);
        }
        if (r.fit === 'missing') missing = (r.missing || [])[0];
      }
      const num = (a, b) => (isNaN(parseFloat(a)) || isNaN(parseFloat(b)) ? 0 : parseFloat(a) - parseFloat(b));
      sizes.sort(num);
      shown.sort(num);
      return { sizes, names: [...names], shown, missing: sizes.length ? null : missing, tried, group };
    }

    // does this product come in the rider's size? (same rules as mx-collection.js)
    fits(p, table, rider) {
      if (!table) return false;
      const byBody = !['helmet', 'boot', 'hat'].includes(table.category);
      if (byBody && (rider.group === 'youth') !== (table.group === 'youth')) return false;
      if (byBody && table.group === 'women' && rider.group !== 'women') return false;
      const sizes = {};
      for (const v of p.v) {
        const hit = String(v)
          .split('/')
          .map((part) => {
            const row = table.rows.find((r) => [r.size, ...Object.values(r.aliases || {})].some((n) => normSize(n) === normSize(part)));
            return row ? row.size : null;
          });
        sizes[v] = hit.every(Boolean) ? hit : null;
      }
      const r = window.MxSizeEngine.recommend(rider, table, { use: p.use, sizes });
      return r.fit === 'good' || r.fit === 'between';
    }

    collectionPath(cat, group) {
      const handle = cat.collections[group] || cat.collections.adult;
      return `/collections/${handle}`;
    }

    // Read the collection's filter options (size groups, vendors) from its own page, then count the filtered result
    async lookup(cat, res, rider) {
      const key = `${cat.key}|${rider.id}|${rider.updated}|${res.names.join(',')}`;
      try {
        let hit = this.cache.get(key);
        if (!hit) {
          const path = this.collectionPath(cat, res.group);
          const base = await this.fetchDoc(path);
          const sizeInputs = [...base.querySelectorAll('input[name^="filter.v.option."]')].filter((i) => /size|st.rrelse/i.test(i.name));
          const params = new URLSearchParams();
          const seen = new Set();
          for (const input of sizeInputs) {
            const label = base.querySelector(`label[for="${CSS.escape(input.id)}"]`);
            const text = (label ? label.textContent : input.value).replace(/\(.*$/s, '').trim().split('\n')[0];
            const n = normSize(text);
            if (res.names.some((s) => normSize(s) === n) && !seen.has(input.value)) {
              seen.add(input.value);
              params.append(input.name, input.value);
            }
          }
          if (!seen.size) throw new Error('no size filter');
          const vendors = new Set([...base.querySelectorAll('input[name="filter.p.vendor"]')].map((i) => i.value));
          (cat.vendors || []).filter((x) => vendors.has(x)).forEach((x) => params.append('filter.p.vendor', x));
          const query = params.toString();
          // count with the same rules as the collection page: the filter can also catch products in the wrong range
          // (e.g. women's Stella trousers in size 26 for a rider saved with men's sizes), so check each product
          const data = await fetch(`${path}?${query}&view=mx-sizes`, { credentials: 'same-origin' }).then((r) => r.json());
          const count = Object.values(data.products).filter((p) => this.fits(p, data.tables[p.t], rider)).length;
          hit = { query, count };
          this.cache.set(key, hit);
        }
        const root = (this.dataset.root || '/').replace(/\/+$/, '');
        return { href: `${root}${this.collectionPath(cat, res.group)}?${hit.query}`, count: hit.count };
      } catch (e) {
        return null;
      }
    }

    async fetchDoc(url) {
      const html = await fetch(url, { credentials: 'same-origin' }).then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      });
      return new DOMParser().parseFromString(html, 'text/html');
    }
  }

  customElements.define('mx-shop-finder', MxShopFinder);
})();
